import React from 'react';
import { IProps, IFormValue } from './types';
import { Formik, Form, Field } from 'formik';
import { LoginAuthenticateType } from 'constants/enums/loginAuthenticateType.enum';
import { MemberProfile } from 'bff/models/member';

/** 身份驗證頁 */
const authentication:React.FC<IProps> = (props) => {
  const initialValues : IFormValue = {
    AuthenticationType: LoginAuthenticateType.Mobile
  };

  /** 格式化顯示文字 */
  const formatAuthenticateType = (str:string, authenticateType:LoginAuthenticateType) => {
    switch (authenticateType) {
      case LoginAuthenticateType.Mobile:
        return str.replace(/^([\d]{4})[\d]{3}([\d]{3})$/, '$1***$2');
      case LoginAuthenticateType.EmailAddr:
        return str.replace(/^(.*).{3}([@]{1})(.*)$/, '$1***$2$3');
    }
  };

  /**
   * @description Form Submit 事件
  */
  const handleFormSubmit = (formVal:IFormValue) => {
    const memberProfile:MemberProfile = {
      MEMBER_ID: props.memberId,
      GENDER: '',
      NAME: '',
      BIRTHDAY: '',
      MOBILE: formVal.AuthenticationType === LoginAuthenticateType.Mobile ? props.memberInfo.MOBILE : '',
      EMAIL_ADDR: formVal.AuthenticationType === LoginAuthenticateType.EmailAddr ? props.memberInfo.EMAIL_ADDR : '',
      HEARING_DISABILITY: '',
      SECQUE_ID: '',
      SECQUE_QUESTION: '',
      SECQUE_ANSWER: '',
      NATIONALITY_ID: '',
      NATIONALITY_TYPE: '',
      MEMBERSHIP: []
    };

    props.onSubmit(memberProfile, true);
  };

  return (
    <div className="authentication auth-block">
      <Formik
        initialValues={initialValues}
        onSubmit={handleFormSubmit}
      >
        {(formProps) => (
          <Form>
            <div className="auth-block__row">
              <p className="auth-block__part">
                使用帳號登入需進行身分驗證<br />
                請選擇一種方式取得驗證碼
              </p>
            </div>
            <div className="auth-block__row">
              <div className="element__radio-group">
                <label htmlFor="phone-radio">
                  <div className="element__radio">
                    <Field type="radio" name="AuthenticationType" id="phone-radio" value={LoginAuthenticateType.Mobile} />
                    <div className="element__radio-btn" />
                  </div>
                  <span>{formatAuthenticateType(props.memberInfo.MOBILE, LoginAuthenticateType.Mobile)}</span>
                </label>
              </div>
              <div className="element__radio-group">
                <label htmlFor="email-radio">
                  <div className="element__radio">
                    <Field type="radio" name="AuthenticationType" id="email-radio" value={LoginAuthenticateType.EmailAddr} />
                    <div className="element__radio-btn" />
                  </div>
                  <span>{formatAuthenticateType(props.memberInfo.EMAIL_ADDR, LoginAuthenticateType.EmailAddr)}</span>
                </label>
              </div>
            </div>
            <div className="auth-block__row">
              <button type="submit" className="element__button element__button--red">發送</button>
              <span className="element__link" onClick={props.onGoBack}>返回上一頁，重新確認帳號</span>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default authentication;
